import * as React from "react";
const SvgSafeSendOn = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 26, height: 24, fill: "none", viewBox: "0 0 26 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M25.31 0H.674c-.928 3.613-3.155 17.93 12.319 24C28.502 17.919 26.238 3.613 25.31 0M21 6.936l-8.43 7.226a1.2 1.2 0 0 1-.783.289 1.2 1.2 0 0 1-.855-.35L7.32 10.49a1.209 1.209 0 1 1 1.71-1.71l2.818 2.83 7.586-6.503A1.204 1.204 0 1 1 21 6.936" }));
export default SvgSafeSendOn;
